import { Skeleton } from '@mui/material';
import React from 'react';


export const PolicyFormSkeleton: React.FC = () => {
  return (
    <>
     <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
    </>
  );
}